<app-ice-back-button
  testId="change-sim-card-back-link"
  (click)="finishedChanging.emit()"
  (keydown.enter)="finishedChanging.emit()"
/>
<div class="sim-card-section">
  <h2 class="sim-card-header">Erstatt SIM-kort</h2>
  <form [formGroup]="form">
    <fieldset>
      <p class="sim-type-header">Hva skal erstattes?</p>
      <app-ice-select-box
        label="Voice-SIM"
        radioTestId="replace-voice-sim-input"
        [control]="simCardType"
        [value]="SimCardType.Voice"
      />
      <app-ice-select-box
        label="Data-SIM"
        radioTestId="replace-data-sim-input"
        [control]="simCardType"
        [disabled]="!hasDataSimCard"
        [value]="SimCardType.Data"
      />
      <app-ice-select-box
        label="Tvilling-SIM"
        radioTestId="replace-twin-sim-input"
        [control]="simCardType"
        [disabled]="!hasTwinSimCard"
        [value]="SimCardType.Twin"
      />
    </fieldset>

    @if (replacedSimOptions.length > 1) {
      <fieldset class="replaced-sim-container">
        <p class="sim-type-header">Hvilket SIM-kort?</p>
        @for (sim of replacedSimOptions; track sim.aNumber; let index = $index) {
          <app-ice-select-box
            [control]="replacedSim"
            [helpLabel]="sim.icc"
            [label]="sim.label"
            [radioTestId]="'replaced-sim-input-' + index"
            [value]="sim.aNumber"
          />
        }
      </fieldset>
    }

    @if (simCardType.value !== SimCardType.Unknown) {
      <fieldset class="sim-card-variant-container">
        <p class="sim-variant-header">Nytt SIM</p>
        @if (displayESim) {
          <app-esim-info-modal />
        }
        <app-ice-select-box
          label="Fysisk SIM-kort"
          radioTestId="physical-sim-input"
          [control]="simCardVariant"
          [value]="SimCardVariant.Physical"
        >
          <div>
            @if (simCardVariant.value !== SimCardVariant.ESim) {
              <app-ice-input-field
                forId="iccInput"
                formControlName="newIcc"
                inputWidth="medium"
                label="SIM-nummeret"
                maxlength="20"
                minlength="19"
                ngDefaultControl
                placeholder="Scan eller skriv inn manuelt"
                textTestId="change-icc-input"
                [errorOnTouchedOnly]="true"
                [errorText]="getSimCardErrorTexts(newIcc.errors, simCardType.value)"
              />
            }
            @if ((newIcc.statusChanges | async) === FormStatus.PENDING) {
              <app-spinner />
            }
          </div>
        </app-ice-select-box>
        @if (displayESim) {
          <app-ice-select-box
            label="eSIM"
            radioTestId="esim-input"
            [control]="simCardVariant"
            [value]="SimCardVariant.ESim"
          />
        }
      </fieldset>
    }
    <app-ice-button color="primary" testId="submit-change-sim-card-button" [disabled]="isSubmitDisabled" (click)="onSave()">
      Ferdig
    </app-ice-button>
  </form>
</div>
